import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=a89f5fb6&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=a89f5fb6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a89f5fb6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a89f5fb6')) {
      api.createRecord('a89f5fb6', component.options)
    } else {
      api.reload('a89f5fb6', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=a89f5fb6&scoped=true&", function () {
      api.rerender('a89f5fb6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-22itpyHuXCIkA/JS/comp/DocBox.vue"
export default component.exports